var URL_SPLIT_PATTERN = /(^(?:https?:)?\/{2,})?([^#?]*)([#?].*)?/;
var SLASH_PATTERN = /\/{2,}/g;
export var normalizeUrl = function normalizeUrl() {
  for (var _len = arguments.length, url = new Array(_len), _key = 0; _key < _len; _key++) {
    url[_key] = arguments[_key];
  }

  return url.join("/").replace(URL_SPLIT_PATTERN, function (m, p1, p2, p3) {
    return [p1 && p1.replace(/\\/g, "/").replace(SLASH_PATTERN, "//"), p2 && p2.replace(/\\/g, "/").replace(SLASH_PATTERN, "/"), p3].filter(Boolean).join("");
  });
};